// extracted by mini-css-extract-plugin
export var availableTimeSetupContainer = "AvailableTimeSetup-module--availableTimeSetupContainer--1D-z6";
export var availableTimeSetupTitle = "AvailableTimeSetup-module--availableTimeSetupTitle--3eneo";
export var availableTimeTargetInput = "AvailableTimeSetup-module--availableTimeTargetInput--3elri";
export var availableTimeTargetSetupSubmitButton = "AvailableTimeSetup-module--availableTimeTargetSetupSubmitButton--2LQxD";
export var backButton = "AvailableTimeSetup-module--backButton--2p4_Q";